import { REQUEST_ATTEMPT_DEFAULT as Ae } from "../common/constants.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
var h = {
  O: {
    Nu: "data",
    wi: "content_cards/sync",
    Le: "feature_flags/sync",
    Er: "template",
    K: "banners/sync"
  },
  Vu: function Vu(t) {
    return null == t ? void 0 : t.ft(s.gt.lE);
  },
  sm: function sm(t) {
    return null == t ? void 0 : t.ft(s.gt.SE);
  },
  nm: function nm(t, e) {
    null == t || t.Bt(s.gt.lE, e);
  },
  rm: function rm(t, e) {
    null == t || t.Bt(s.gt.SE, e);
  },
  zu: function zu(t, e) {
    if (!t || !e) return -1;
    var s = h.Vu(t);
    if (null == s) return -1;
    var n = s[e];
    return null == n || isNaN(n) ? -1 : n;
  },
  ju: function ju(t, e) {
    var s = Ae;
    if (!t || !e) return s;
    var n = h.sm(t);
    return null == n ? s : (s = n[e], null == s || isNaN(s) ? Ae : s);
  },
  W: function W(t, e, s) {
    if (!t || !e) return;
    var n = h.Vu(t);
    null == n && (n = {}), n[e] = s, h.nm(t, n);
  },
  Mu: function Mu(t, e, s) {
    if (!t || !e) return;
    var n = h.sm(t);
    null == n && (n = {}), n[e] = s, h.rm(t, n);
  },
  vi: function vi(t, e) {
    t && e && h.Mu(t, e, Ae);
  },
  Uu: function Uu(t, e) {
    if (!t || !e) return;
    var s = h.ju(t, e);
    h.Mu(t, e, s + 1);
  }
};
export default h;